import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
} from "../services/toast";
import axiosInstance from "../services/axiosInstance";

export const guidanceForEmissionActivityAPI = {
  ////////取得事業基本資料
  async getSchoolBasicInfo(id, year) {
    try {
      const response = await axiosInstance.get(`/api/school/basic_info`, {
        params: {
          orgId: id,
          year: year,
        },
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching school basic info:", err);
    }
  },

  ///////取得行政院主計總處行業統計分類之行業代碼清單
  async getIndustryOptionInfo() {
    try {
      const response = await axiosInstance.get(`/api/system/industry_code`);
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching industry code:", err);
    }
  },

  ///////取得目的事業主管機關
  async getAuthorityCode() {
    try {
      const response = await axiosInstance.get(`/api/system/authority_code`);
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching authority code:", err);
    }
  },

  ///////取得檢驗機官清單
  async getVerificationOrgCode() {
    try {
      const response = await axiosInstance.get(
        `/api/system/verification_org_code`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching verification org code:", err);
    }
  },

  /////////新增事業基本資料
  async addSchoolBasicInfo(data) {
    try {
      const response = await axiosInstance.post(`/api/school/basic_info`, data);
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_BASIC_INFO_CREATE_SUCCESS,
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error adding school basic info:", err);
    }
  },

  /////////更新事業基本資料
  async updateSchoolBasicInfo(id, data) {
    const requestBody = data;
    try {
      const response = await axiosInstance.put(
        `/api/school/basic_info/${id}`,
        requestBody,
      );
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_BASIC_INFO_UPDATE_SUCCESS,
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error adding school basic info:", err);
    }
  },

  /////////取得「事業應盤查登錄溫室氣體排放量之排放源」之納管行業別及條件
  async getEmissionRegulatedIndustry() {
    try {
      const response = await axiosInstance.get(
        `/api/system/emission_regulated_industry`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching emission regulated industry:", err);
    }
  },

  ///////取得縣市及其所屬行政區清單
  async getCitiesWithDistrictsInfo() {
    try {
      const response = await axiosInstance.get(
        `/api/system/cities_with_districts`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching cities_with_districts:", err);
    }
  },

  ///////取得取得邊界設定清單
  async getBoundarySite(id, year) {
    try {
      const response = await axiosInstance.get(`/api/school/boundary_site`, {
        params: {
          orgId: id,
          year: year,
        },
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching boundary_site:", err);
    }
  },

  //////修改邊界設定
  async updateBoundarySite(data) {
    const requestBody = {
      data: data,
    };
    try {
      const response = await axiosInstance.post(
        `/api/school/boundary_site`,
        requestBody,
      );
      console.log("updateBoundarySite", response.data.data);
      return response.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error update feedback", err);
    }
  },

  //刪除邊界設定
  async deleteBoundarySite(org_id, ids) {
    const requestBody = {
      rootId: org_id,
      ids: ids,
    };
    try {
      const response = await axiosInstance.delete(`/api/school/boundary_site`, {
        data: requestBody,
      });
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_BOUNDARY_SITE_DELETE_SUCCESS,
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error delete feedback", err);
      return []; // 失敗時回傳 null
    }
  },

  ///////取得排放源群組設定 (初始化建制)
  async getEmissionSetting(orgId, companyId, year) {
    try {
      const response = await axiosInstance.post(
        `/api/school/emission_setting`,
        {}, // body 留空
        {
          params: {
            orgId,
            companyId,
            year,
          },
        },
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching emission_setting:", err);
    }
  },

  //////修改排放源群組設定
  async updateEmissionSetting(
    year,
    orgId,
    companyId,
    editedEmissionStates,
    editedMaterialStates,
  ) {
    const requestBody = {
      year: year,
      rootId: orgId,
      companyId: companyId,
      Equipment_Setting: editedEmissionStates,
      Material_Setting: editedMaterialStates,
    };
    try {
      const response = await axiosInstance.post(
        `/api/school/emission_setting/bulk`,
        requestBody,
      );
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_EMISSION_SETTING_UPDATE_SUCCESS,
      });
      // console.log("updateEmissionSetting", response.data.data);
    } catch (err) {
      handleAPIError(err);
      console.error("Error emission setting", err);
    }
  },

  ////////取得機構/部門編號及名稱
  async getDepartmentOptionInfo(orgId, year) {
    try {
      const response = await axiosInstance.get(
        `/api/school/boundary_site_dropdown_list`,
        {
          params: {
            year: year,
            orgId: orgId,
          },
        },
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching department_code:", err);
    }
  },

  ////////api/system/equipment_code
  async getEquipmentOptionInfo(year) {
    try {
      const response = await axiosInstance.get(`/api/system/equipment_code`, {
        params: {
          year: year,
          // companyId: companyId,
        },
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching equipment_code:", err);
    }
  },

  ////////api/system/equipment_code
  async getMaterialOptionInfo(year) {
    try {
      const response = await axiosInstance.get(`/api/system/material_code`, {
        params: {
          year: year,
          // companyId: companyId,
        },
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching material_code:", err);
    }
  },

  ///取的量測頻率
  async getMeasurementFrequencyOptionInfo() {
    try {
      const response = await axiosInstance.get(
        `/api/system/measurement_frequency`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching measurement frequency:", err);
    }
  },

  ///////取得活動清單(新增排放源，我的排放源)
  async getActivityList(orgId, companyId, year) {
    // 動態建立 params，companyId 沒有值，會傳 ?orgId=xxx&year=2025
    const params = { orgId, year };
    if (companyId) {
      params.companyId = companyId;
    }
    try {
      const response = await axiosInstance.get(`/api/school/activity_list`, {
        params,
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching activity_list:", err);
    }
  },

  async updateNewEmissionSource(rowData, userId) {
    const dynamicFields = [
      "customFugitiveEmissionRate",
      "refrigerantCalculationId",
      "process_fugitive_purchased_energy_category",
      "electricity_steam_source",
      "is_biogenic_fuel",
      "other_process_fugitive_category_desc",
      "process_emission_removal_rate",
    ];

    const requestBody = {
      data: rowData.map((row) => {
        const baseData = {
          year: row.year,
          rootId: row.rootId,
          companyId: row.companyId,
          category: row.category,
          userId: row.userId || userId,
          custodian_name: row.custodian_name,
          department_name: row.department_name,
          department_id: row.department_id,
          equipment_no: row.equipment_no,
          property_no: row.property_no,
          equipment_code: row.equipment_code,
          equipment_detail: row.equipment_detail,
          equipment_quantity: row.equipment_quantity,
          equipment_desc: row.equipment_desc,
          material_code: row.material_code,
          material_type_code: row.material_type_code,
          equipment_type_code: row.equipment_type_code,
        };

        dynamicFields.forEach((key) => {
          if (row[key] != null && row[key] !== "") {
            // 檢查是否為目標欄位，如果是，強制轉為 String
            if (key === "process_fugitive_purchased_energy_category") {
              baseData[key] = String(row[key]);
            } else {
              baseData[key] = row[key];
            }
          }
        });

        // 4. 判斷更新或新增 (使用物件展開讓程式碼更簡練)
        return row.id && row.activityId
          ? { id: row.id, activityId: row.activityId, ...baseData }
          : baseData;
      }),
    };
    try {
      const response = await axiosInstance.post(
        `/api/school/activity_list`,
        requestBody,
      );
      console.log("requestBody", requestBody);
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_EMISSION_SOURCE_UPDATE_SUCCESS,
      });
    } catch (err) {
      handleAPIError(err);
      console.error("Error update new emission source", err);
    }
  },

  ////刪除排放源
  async deleteNewEmissionSource(org_id, ids) {
    const requestBody = {
      rootId: org_id,
      ids: ids,
    };
    try {
      const response = await axiosInstance.delete(`/api/school/activity_list`, {
        data: requestBody,
      });
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_EMISSION_SOURCE_DELETE_SUCCESS,
      });
      return response.data.data; // 返回 API 的資料
    } catch (error) {
      handleAPIError(error);
      console.error("Error delete New Emission Source :", error);
      return []; // 失敗時回傳 null
    }
  },

  ////////update ActivityData
  async updateActivityData(rowData) {
    const requestBody = {
      data: rowData.map((row) => ({
        id: row.id,
        activityId: row.activityId,
        category: row.category,
        equipment_code: row.equipment_code,
        material_code: row.material_code,
        equipment_no: row.equipment_no,
        is_used_current_year: row.is_used_current_year,
        activity_share_percent: row.activity_share_percent,
        data_source: row.data_source,
        storage_unit: row.storage_unit,
        measurement_frequency: row.measurement_frequency,
        measurement_device: row.measurement_device,
        department_name: row.department_name,
        department_id: row.department_id,
        fuel_heat_carbon_source: row.fuel_heat_carbon_source,
        carbon_content: row.carbon_content,
        fuel_heat_carbon_data_source: row.fuel_heat_carbon_data_source,
      })),
    };

    try {
      const response = await axiosInstance.post(
        `/api/school/activity_list`,
        requestBody,
      );
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_ACTIVITY_DATA_UPDATE_SUCCESS,
      });
      console.log("requestBody", requestBody);
    } catch (err) {
      handleAPIError(err);
      console.error("Error update activity data", err);
    }
  },

  ///////update TestingMethodAndDate
  async updateTestingMethodAndDate(rowData) {
    const requestBody = {
      data: rowData.map((row) => ({
        id: row.id,
        activityId: row.activityId,
        category: row.category,
        equipment_code: row.equipment_code,
        material_code: row.material_code,
        equipment_no: row.equipment_no,
        lab_name: row.lab_name,
        lab_certification: row.lab_certification,
        low_heating_carbon_value: row.low_heating_carbon_value,
        parameter_value: row.parameter_value,
        parameter_unit: row.parameter_unit,
        method_code: row.method_code,
        method_name: row.method_name,
        test_date_start: row.test_date_start,
        test_date_end: row.test_date_end,
        test_frequency: row.test_frequency,
        department_name: row.department_name,
        department_id: row.department_id,
        test_frequency_unit: row.test_frequency_unit, //檢測頻率單位
      })),
    };

    try {
      const response = await axiosInstance.post(
        `/api/school/activity_list`,
        requestBody,
      );
      console.log("requestBody", requestBody);
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_TESTING_METHOD_UPDATE_SUCCESS,
      });
    } catch (err) {
      handleAPIError(err);
      console.error("Error update TestingMethodAndDate", err);
    }
  },

  //取得客戶底下的公司與使用者權限列表
  async getAuthListAPI(rootId) {
    try {
      const response = await axiosInstance.get(
        `/org/orguser/auth_list/${rootId}`,
      );
      return response.data.data; // 根據回傳結構，也許你需要改成 response.data.data
    } catch (error) {
      handleAPIError(error);
      console.error("Error fetching auth list:", error);
      return null;
    }
  },

  //////// 下載邊界設定 Excel
  async downloadBoundarySettingExcel(orgId, year) {
    const params = {
      orgId: orgId,
      year: year,
    };

    try {
      const response = await axiosInstance.get(
        `/api/school/boundary_site/download`,
        {
          params: params,
          responseType: "blob", // 設定回應類型為 Blob，確保能接收二進制檔案
          timeout: 300000,
        },
      );

      // 創建 Blob 物件
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 創建下載連結
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "download.xlsx"; // 預設檔名
      if (contentDisposition) {
        const filenameRegex = /filename\*=UTF-8''([^;]+)/;
        const matches = filenameRegex.exec(contentDisposition);

        if (matches && matches[1]) {
          fileName = decodeURIComponent(matches[1]);
        } else {
          // 如果沒有 UTF-8 編碼,嘗試普通 filename
          const fallbackRegex = /filename="?([^";\n]+)"?/;
          const fallbackMatches = fallbackRegex.exec(contentDisposition);
          if (fallbackMatches && fallbackMatches[1]) {
            // 嘗試解碼可能的 URI 編碼
            try {
              fileName = decodeURIComponent(fallbackMatches[1]);
            } catch (e) {
              fileName = fallbackMatches[1];
            }
          }
        }
      }

      link.href = downloadUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click(); // 自動點擊下載
      document.body.removeChild(link); // 下載後移除連結
    } catch (err) {
      handleAPIError(err);
      console.error("Error downloading boundary setting excel", err);
    }
  },

  //////// 下載活動清單 Excel
  async downloadActivityListExcel(selectedPage, orgId, year, selectedCom) {
    const params = {
      operation: selectedPage === 4 ? "create" : "update",
      orgId: orgId,
      year: year,
      ...(selectedCom !== "all" && { companyId: selectedCom }),
      // companyId: selectedCom === "all" ? "" : selectedCom,
    };

    try {
      const response = await axiosInstance.get(
        `/api/school/activity_list/download`,
        {
          params: params,
          responseType: "blob", // 設定回應類型為 Blob，確保能接收二進制檔案
          timeout: 300000,
        },
      );

      // 創建 Blob 物件
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 創建下載連結
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "download.xlsx";
      if (contentDisposition) {
        // 優先解析 filename*=
        const utf8FileNameMatch = contentDisposition.match(
          /filename\*=UTF-8''([^;]+)/,
        );
        const asciiFileNameMatch =
          contentDisposition.match(/filename="?([^"]+)"?/);

        if (utf8FileNameMatch) {
          fileName = decodeURIComponent(utf8FileNameMatch[1]);
        } else if (asciiFileNameMatch) {
          fileName = asciiFileNameMatch[1];
        }
      }
      link.href = downloadUrl;
      // link.setAttribute("download", `${matchFileName[1]}`); // 設定下載的檔名
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click(); // 自動點擊下載
      document.body.removeChild(link); // 下載後移除連結
    } catch (err) {
      handleAPIError(err);
      console.error("Error downloading boundary setting excel", err);
    }
  },

  ////////上傳邊界設定 Excel
  async uploadBoundarySiteExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axiosInstance.post(
        `/api/school/boundary_site/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 確保 Content-Type 正確
          },
        },
      );

      // 顯示成功的 Toast
      if (response.data.success === false) {
        handleAPIError(null, {
          apiData: response.data
        });
      } else {
        showSuccessToast({
          apiData: response.data,
          scenarioCode: MESSAGE_CODES.FILE_UPLOAD_SUCCESS,
        });
      }
      return response;
    } catch (err) {
      console.error("Error uploading Excel", err);
      handleAPIError(err);
    }
  },

  ////////上傳活動清單 Excel
  async uploadActivityListExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axiosInstance.post(
        `/api/school/activity_list/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 確保 Content-Type 正確
          },
        },
      );

      // 顯示成功的 Toast
      if (response.data.success === false) {
        handleAPIError(null, {
          apiData: response.data
        });
      } else {
        showSuccessToast({
          apiData: response.data,
          scenarioCode: MESSAGE_CODES.FILE_UPLOAD_SUCCESS,
        });
      }
      return response;
    } catch (err) {
      console.error("Error uploading Excel", err);
      handleAPIError(err);
    }
  },

  ///////取得單位部門清單
  async getUnitDepartment(id, year) {
    try {
      const response = await axiosInstance.get(
        `/api/school/departments_users`,
        {
          params: {
            orgId: id,
            year: year,
          },
        },
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching boundary_site:", err);
    }
  },

  //刪除單位部門清單
  async deleteUnitDepartment(ids) {
    // const idArray = ids.map(item => item.id || item);
    try {
      const response = await axiosInstance.delete(
        `/api/school/departments_users`,
        { data: ids },
      );
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_UNIT_DEPARTMENT_DELETE_SUCCESS,
      });
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error delete list", err);
      return []; // 失敗時回傳 null
    }
  },

  ///////取得部門使用者清單下拉選單
  async getUnitDepartmentUserDropdown(id, year) {
    try {
      const response = await axiosInstance.get(
        `/api/school/departments_users_dropdown_list`,
        {
          params: {
            orgId: id,
            year: year,
          },
        },
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching departments_users_dropdown_list:", err);
    }
  },

  ///更新單位部門
  async updateUnitDepartment(rowData, selectedYear, userId) {
    const requestBody = {
      data: rowData.map((row) => {
        const baseData = {
          year: selectedYear,
          rootId: row.rootId,
          companyId: row.companyId,
          dept_name: row.name,
          userIds: row.users && row.users.length > 0 ? row.users : [userId],
        };
        // 如果有 id 表示是更新操作，需要加入這兩個欄位
        if (row.id) {
          return {
            id: row.id,
            ...baseData,
          };
        }
        // 否則是新增操作，只返回基本資料
        return baseData;
      }),
    };
    try {
      const response = await axiosInstance.post(
        `/api/school/departments_users/bulk`,
        requestBody,
      );
      console.log("requestBody", requestBody);
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.GUIDANCE_UNIT_DEPARTMENT_UPDATE_SUCCESS,
      });
    } catch (err) {
      handleAPIError(err);
      console.error("Error update unit department", err);
    }
  },

  ///////取得排放類別選項
  async getEmissionSelectOptions() {
    try {
      const response = await axiosInstance.get(
        `/api/system/emission_select-options
`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching emission select options:", err);
    }
  },

  //燃料熱值/碳含量來源(下拉)
  async getFuelHeatCarbonSourceLookup() {
    try {
      const response = await axiosInstance.get(
        `/api/system/fuel_heat_carbon_source_lookup`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching fuel heat carbon source lookup:", err);
    }
  },

  //實驗室/檢測機構認證資格(下拉)
  async getLabAccreditationQualificationLookup() {
    try {
      const response = await axiosInstance.get(
        `/api/system/lab_accreditation_qualification_lookup`,
      );
      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error(
        "Error fetching lab accreditation qualification lookup:",
        err,
      );
    }
  },

  //檢測方法
  async getTestingMethodLookup() {
    try {
      const response = await axiosInstance.get(
        `/api/system/test_method_lookup`,
      );

      return response.data.data;
    } catch (err) {
      handleAPIError(err);
      console.error("Error fetching testing method lookup:", err);
    }
  },
};
